import { useState } from "react";
import useSWR from "swr";
import { ImageOff, Loader2 } from "lucide-react";
import { swrFetcher } from "@/lib/api";

export function ReferenceThumb({ assetId, label }: { assetId: string; label: string }) {
  const { data, error } = useSWR<{url:string}>(`/api/assets/presign?asset_id=${encodeURIComponent(assetId)}`, swrFetcher, { refreshInterval: 40*60*1000 });
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  if (error || (data?.url && failedUrl === data.url)) return <ImageOff aria-label={`${label}: preview unavailable`} className="h-4 w-4 text-studio-warning" />;
  if (!data?.url) return <Loader2 aria-label={`${label}: preparing preview`} className="h-4 w-4 animate-spin" />;
  return <img src={data.url} alt={label} onError={() => setFailedUrl(data.url)} className="h-full w-full object-cover" />;
}
